module.exports = __webpack_public_path__ + "static/media/greenicon.d44d2204.jpg";